import { createContext, useContext, useState } from "react";

const translations = {
  es: {
    // General
    appName: "SALLY | Better Menú",
    loading: "Cargando...",
    
    // Auth
    login: "Iniciar Sesión",
    register: "Crear Cuenta",
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre",
    welcomeBack: "¡Bienvenido de nuevo!",
    loginDescription: "Ingresa tus credenciales para acceder a tus menús",
    createAccount: "Crear cuenta",
    alreadyHaveAccount: "Ya tengo cuenta",
    
    // Dashboard
    myMenus: "Mis Menús",
    manageMenus: "Gestiona tus menús digitales",
    newMenu: "Nuevo Menú",
    createMenu: "Crear Menú",
    menuName: "Nombre del menú",
    creating: "Creando...",
    cancel: "Cancelar",
    hello: "Hola",
    mobileLink: "Link Móvil",
    language: "Idioma",
    logout: "Salir",
    noMenusYet: "Aún no tienes menús",
    createFirstMenu: "Crea tu primer menú para comenzar",
    edit: "Editar",
    items: "elementos",
    updated: "Actualizado",
    template: "Plantilla",
    selectTemplate: "Selecciona una plantilla para comenzar",
    copyPublicLink: "Copiar enlace público",
    generateQR: "Generar código QR",
    openPublicLink: "Abrir enlace público",
    deleteMenu: "Eliminar menú",
    duplicateMenu: "Duplicar menú",
    menuDuplicated: "Menú duplicado",
    
    // Locations
    locations: "Ubicaciones",
    newLocation: "Nueva Ubicación",
    createLocation: "Crear Ubicación",
    locationName: "Nombre de la ubicación",
    address: "Dirección",
    description: "Descripción",
    noLocationsYet: "Sin ubicaciones",
    createFirstLocation: "Crea tu primera ubicación",
    allMenus: "Todos los Menús",
    menusInLocation: "Menús en esta ubicación",
    noMenusInLocation: "Sin menús en esta ubicación",
    locationCreated: "Ubicación creada",
    locationDeleted: "Ubicación eliminada",
    deleteLocation: "Eliminar ubicación",
    editLocation: "Editar ubicación",
    confirmDeleteLocation: "Eliminar ubicación",
    confirmDeleteLocationDesc: "¿Estás seguro que deseas eliminar",
    deleteLocationWarning: "Los menús asociados a esta ubicación serán desvinculados pero no eliminados.",
    delete: "Eliminar",
    moveMenu: "Mover menú",
    moveMenuDescription: "Selecciona la nueva ubicación para",
    selectNewLocation: "Nueva ubicación",
    noLocation: "Sin ubicación",
    move: "Mover",
    menuMoved: "Menú movido",
    
    // QR Dialog
    qrCode: "Código QR",
    scanToView: "Escanea este código para ver el menú público",
    copyLink: "Copiar enlace",
    downloadQR: "Descargar QR",
    
    // Editor
    back: "Volver",
    save: "Guardar",
    saving: "Guardando...",
    preview: "Vista previa",
    addText: "Texto",
    addImage: "Imagen",
    addShape: "Forma",
    textType: "Tipo",
    textName: "Nombre",
    textPrice: "Precio",
    image: "Imagen",
    textContent: "Contenido",
    add: "Añadir",
    uploadImage: "Subir imagen",
    uploadBackground: "Fondo",
    configuration: "Configuración",
    selectImage: "Seleccionar imagen",
    imageAdded: "Imagen añadida",
    noBackground: "Sube una imagen de fondo para comenzar",
    
    // Layers
    layers: "Capas",
    bringToFront: "Traer al frente",
    sendToBack: "Enviar atrás",
    bringForward: "Subir capa",
    sendBackward: "Bajar capa",
    layer: "Capa",
    
    // Canvas settings
    configureCanvasSize: "Configurar Canvas",
    presets: "Presets",
    custom: "Personalizado",
    width: "Ancho",
    height: "Alto",
    aspectRatio: "Proporción",
    refreshInterval: "Intervalo de actualización (seg)",
    refreshDescription: "Frecuencia de refresco en vista pública",
    apply: "Aplicar",
    
    // Properties panel
    properties: "Propiedades",
    text: "Texto",
    label: "Etiqueta",
    labelPlaceholder: "Ej: Pizza Margherita...",
    labelHint: "Aparece en la lista móvil",
    textShadow: "Sombra",
    shadowHint: "Mejora legibilidad",
    font: "Fuente",
    fontSize: "Tamaño",
    fontWeight: "Peso",
    color: "Color",
    position: "Posición",
    size: "Tamaño",
    opacity: "Opacidad",
    deleteItem: "Eliminar",
    
    // Menu items list
    menuItems: "Elementos",
    noItemsYet: "No hay elementos",
    selectItemOnCanvas: "Selecciona un item en el canvas para editar sus propiedades",
    
    // Toolbar
    selectMode: "Selección",
    panMode: "Mover vista",
    undo: "Deshacer",
    redo: "Rehacer",
    cut: "Cortar",
    copy: "Copiar",
    paste: "Pegar",
    
    // Mobile
    mobileEdit: "Edición Móvil",
    selectMenu: "Selecciona un menú",
    searchPlaceholder: "Buscar...",
    noResults: "Sin resultados",
    tryAnotherSearch: "Intenta otra búsqueda",
    clearSearch: "Limpiar",
    noTextsInMenu: "No hay textos",
    addTextsFromDesktop: "Agrega desde el editor",
    changesReflected: "Los cambios se verán en la vista pública al guardar",
    
    // Toasts
    menuCreated: "Menú creado",
    menuDeleted: "Menú eliminado",
    menuSaved: "Menú guardado",
    linkCopied: "Enlace copiado",
    mobileLinkCopied: "Link móvil copiado",
    qrDownloaded: "QR descargado",
    nameUpdated: "Nombre actualizado",
    configUpdated: "Configuración actualizada",
    textCopied: "Copiado",
    textCut: "Cortado",
    textPasted: "Pegado",
    changeUndone: "Deshecho",
    changeRedone: "Rehecho",
    itemDeleted: "Eliminado",
    itemAdded: "Añadido",
    imageUploaded: "Imagen subida",
    export: "Exportar",
    exportPNG: "Exportar como PNG",
    exportJPG: "Exportar como JPG",
    imageExported: "Imagen exportada",
    
    // Admin
    adminPanel: "Panel de Administración",
    adminAccessRequired: "Acceso de administrador requerido",
    userManagement: "Gestión de Usuarios",
    manageAllUsers: "Administra todos los usuarios del sistema",
    addUser: "Agregar Usuario",
    editUser: "Editar Usuario",
    addUserDesc: "Crear una nueva cuenta de usuario",
    editUserDesc: "Modificar información del usuario",
    searchUsers: "Buscar usuarios...",
    totalUsers: "Total Usuarios",
    activeUsers: "Usuarios Activos",
    totalMenus: "Total Menús",
    totalLocations: "Total Ubicaciones",
    role: "Rol",
    status: "Estado",
    created: "Creado",
    actions: "Acciones",
    active: "Activo",
    inactive: "Inactivo",
    activate: "Activar",
    deactivate: "Desactivar",
    userCreated: "Usuario creado",
    userUpdated: "Usuario actualizado",
    userDeleted: "Usuario eliminado",
    userActivated: "Usuario activado",
    userDeactivated: "Usuario desactivado",
    confirmDeleteUser: "Eliminar usuario",
    confirmDeleteUserDesc: "¿Estás seguro que deseas eliminar al usuario",
    deleteUserWarning: "Se eliminarán todos los menús y ubicaciones asociados a este usuario.",
    fillAllFields: "Completa todos los campos",
    passwordRequired: "La contraseña es requerida",
    leaveBlank: "dejar vacío para mantener",
    accountActive: "Cuenta activa",
    noUsersYet: "No hay usuarios aún",
    create: "Crear",
    
    // Suspension
    suspended: "Suspendido",
    suspendService: "Suspender servicio",
    suspendServiceDesc: "Suspender el servicio de",
    suspensionMessage: "Mensaje de suspensión",
    suspensionMessagePlaceholder: "Este servicio está temporalmente suspendido...",
    suspensionMessageHelp: "Este mensaje se mostrará en todos los menús públicos del usuario.",
    suspend: "Suspender",
    userSuspended: "Servicio suspendido",
    reactivateService: "Reactivar servicio",
    serviceReactivated: "Servicio reactivado",
    
    // Stats detail dialogs
    clickToViewAll: "Click para ver todos",
    allMenus: "Todos los Menús",
    allMenusDesc: "Lista de todos los menús del sistema",
    searchMenus: "Buscar menús...",
    owner: "Propietario",
    viewPublic: "Ver público",
    allLocations: "Todas las Ubicaciones",
    allLocationsDesc: "Lista de todas las ubicaciones del sistema",
    searchLocations: "Buscar ubicaciones...",
    menus: "menús",
    noResults: "Sin resultados",
    noLocationsYet: "No hay ubicaciones aún",
    
    // Dashboard - Slideshows
    slideshows: "Slideshows",
    slideshowsDesc: "Agrupa varios menús en una presentación rotativa",
    newSlideshow: "Nuevo Slideshow",
    editSlideshow: "Editar Slideshow",
    schedule: "Horario",
    configureSchedule: "Configurar Horario",
    saveSchedule: "Guardar Horario",
    createSlideshow: "Crear Slideshow",
    createSlideshowDesc: "Configura una presentación con múltiples menús",
    slideshowName: "Nombre del Slideshow",
    locationOptional: "Ubicación (opcional)",
    transitionEffect: "Efecto de Transición",
    fade: "Fade (Desvanecer)",
    slide: "Slide (Deslizar)",
    noTransition: "Sin transición",
    availableMenus: "Menús disponibles",
    menusInSlideshow: "Menús en el slideshow",
    scanToViewSlideshow: "Escanea para ver el slideshow",
    addMenus: "Agregar menús",
    modifySlideshowConfig: "Modifica la configuración del slideshow",
    noMenusAvailable: "No hay menús disponibles",
    selectLocation: "Seleccionar ubicación",
    allLocations: "Todas las ubicaciones",
    
    // Dashboard - Calendars
    calendars: "Calendarios",
    newCalendar: "Nuevo Calendario",
    calendarName: "Nombre del calendario",
    timezone: "Zona horaria",
    autoDetected: "detectada automáticamente",
    defaultContent: "Contenido por defecto",
    weeklySchedule: "Horario semanal",
    dateExceptions: "Excepciones de fecha",
    addException: "Agregar excepción",
    noScheduleForDay: "Sin contenido programado para este día",
    publicLink: "Enlace público",
    confirmTimezone: "¿Es correcta la zona horaria?",
    
    // Landing Page
    landing_hero_badge: "Plataforma de Menús Digitales #1",
    landing_hero_title: "Transforma tu menú en una",
    landing_hero_title_highlight: "experiencia digital",
    landing_hero_description: "Crea menús digitales impresionantes para tu restaurante, cafetería o bar. Actualiza precios, añade promociones y programa contenido automáticamente.",
    landing_hero_email_placeholder: "Tu correo electrónico",
    landing_hero_request_demo: "Solicitar Demo",
    landing_hero_no_credit: "Sin tarjeta de crédito",
    landing_hero_setup_minutes: "Configuración en minutos",
    landing_hero_support_included: "Soporte incluido",
    landing_features_badge: "CARACTERÍSTICAS",
    landing_features_title: "Todo lo que necesitas para",
    landing_features_highlight: "brillar",
    landing_features_desc: "Herramientas poderosas y fáciles de usar para crear menús digitales que cautivan a tus clientes",
    landing_usecases_badge: "CASOS DE USO",
    landing_usecases_title: "Perfecto para tu",
    landing_usecases_highlight: "negocio",
    landing_usecases_desc: "Diseñado para restaurantes, cafeterías, bares y cualquier establecimiento que quiera modernizar su carta",
    landing_pricing_badge: "PRECIOS",
    landing_pricing_title: "Planes para cada",
    landing_pricing_highlight: "necesidad",
    landing_pricing_desc: "Comienza y escala cuando lo necesites. Sin compromisos, cancela cuando quieras.",
    landing_cta_title: "¿Listo para transformar tu menú?",
    landing_cta_desc: "Únete a cientos de restaurantes que ya están usando Sally Better para crear experiencias digitales únicas para sus clientes.",
    landing_start_now: "Comenzar Ahora",
    landing_view_demo: "Ver Demo",
    landing_feature_editor: "Editor Visual Drag & Drop",
    landing_feature_editor_desc: "Diseña menús profesionales sin conocimientos técnicos. Arrastra y suelta elementos fácilmente.",
    landing_feature_calendar: "Programación por Calendario",
    landing_feature_calendar_desc: "Programa automáticamente qué menú mostrar según el día y la hora. Desayuno, almuerzo, cena.",
    landing_feature_timezone: "Múltiples Zonas Horarias",
    landing_feature_timezone_desc: "Gestiona restaurantes en diferentes ciudades con zonas horarias independientes.",
    landing_feature_widgets: "Widgets Dinámicos",
    landing_feature_widgets_desc: "Añade reloj digital, pronóstico del clima, noticias RSS y texto animado.",
    landing_feature_slideshows: "Slideshows Automáticos",
    landing_feature_slideshows_desc: "Crea presentaciones rotativas de múltiples menús con transiciones suaves.",
    landing_feature_qr: "Códigos QR Únicos",
    landing_feature_qr_desc: "Genera códigos QR para cada menú. Tus clientes escanean y ven el menú actualizado.",
    landing_feature_videos: "Videos e Imágenes",
    landing_feature_videos_desc: "Soporta videos de YouTube, Vimeo y archivos directos para menús más atractivos.",
    landing_feature_shapes: "Formas y Animaciones",
    landing_feature_shapes_desc: "Añade formas geométricas y animaciones de entrada para captar la atención.",
    landing_usecase_restaurants: "Restaurantes",
    landing_usecase_restaurants_desc: "Menús digitales que se actualizan instantáneamente. Cambia precios, añade platos del día y promociones en segundos.",
    landing_usecase_cafes: "Cafeterías",
    landing_usecase_cafes_desc: "Muestra tu carta de cafés, pasteles y promociones matutinas. Programa menús de desayuno automáticamente.",
    landing_usecase_bars: "Bares",
    landing_usecase_bars_desc: "Carta de bebidas, happy hour y eventos especiales. Actualiza precios y promociones nocturnas al instante.",
    landing_plan_basic: "Básico",
    landing_plan_basic_desc: "Perfecto para empezar",
    landing_plan_pro: "Profesional",
    landing_plan_pro_desc: "Para restaurantes en crecimiento",
    landing_plan_enterprise: "Enterprise",
    landing_plan_enterprise_desc: "Para cadenas y franquicias",
    landing_most_popular: "Más Popular",
    landing_contact_sales: "Contactar Ventas",
    landing_per_month: "/mes",
    landing_custom: "Personalizado",
    landing_contact_form_title: "Completa tus datos y te contactaremos pronto",
    landing_full_name: "Nombre completo",
    landing_phone: "Teléfono",
    landing_business_name: "Nombre del negocio",
    landing_message: "Mensaje (opcional)",
    landing_message_placeholder: "Cuéntanos más sobre tus necesidades...",
    landing_send_request: "Enviar Solicitud",
    landing_sending: "Enviando...",
    landing_message_sent: "¡Mensaje enviado! Te contactaremos pronto.",
    landing_message_error: "Error al enviar el mensaje. Intenta de nuevo.",
    landing_fill_required: "Por favor completa nombre y email",
    
    // Landing - New Print + Digital Plans
    landing_plan_250: "Plan 250",
    landing_plan_250_price: "$165",
    landing_plan_250_desc: "Ideal para restaurantes pequeños o en crecimiento",
    landing_plan_500: "Plan 500",
    landing_plan_500_price: "$325",
    landing_plan_500_desc: "Para restaurantes establecidos",
    landing_plan_1000: "Plan 1000",
    landing_plan_1000_price: "$650",
    landing_plan_1000_desc: "Máximo control y presencia",
    landing_premium: "PREMIUM",
    
    // Plan features
    landing_menus_printed: "menús impresos",
    landing_double_sided_glossy: "doble lado (glossy)",
    landing_print_digital_design: "Diseño de Menú impreso y Digital",
    landing_unlimited_changes: "Agrega productos y cambios de precios sin límites",
    landing_digital_panel_access: "Acceso a panel de control de Menú Digital",
    landing_seasonal_changes: "cambio de diseño por temporada",
    landing_seasonal_changes_plural: "cambios de diseño por temporada",
    landing_menu_with_qr: "Menú con Código QR",
    landing_personalized_admin: "Administración personalizada de su Menú Digital",
    landing_priority_support: "Soporte prioritario",
    landing_includes_plan: "Características del Plan",
    
    // Landing - All in One Section
    landing_allinone_badge: "LA SOLUCIÓN TODO EN UNO",
    landing_allinone_title: "Menú Profesional",
    landing_allinone_highlight: "Impreso + Digital",
    landing_allinone_desc: "Un solo pago mensual, control total e imagen profesional para tu restaurante",
    landing_allinone_feature1: "Diseño Gráfico Profesional",
    landing_allinone_feature2: "Impresión y Materiales de alta calidad",
    landing_allinone_feature3: "Cambios de precios y productos ilimitados",
    landing_allinone_feature4: "Diseño menú por temporada",
    landing_allinone_feature5: "Menú con Código QR",
    landing_allinone_feature6: "Menú digital para pantallas, con acceso desde laptop, tablet o celular",
    
    // Landing - Problems Section
    landing_problems_title: "¿Tu menú está desactualizado?",
    landing_problem1: "Cambios de diseño costosos",
    landing_problem2: "Reimprimir cuando cambias precios o agregas productos nuevos",
    landing_problem3: "El mismo diseño todos los años",
    landing_problem4: "Pantallas sin actualizar",
    landing_problems_quote: "Tu restaurante cambia constantemente.",
    landing_problems_quote2: "Tu menú también debería hacerlo.",
    
    // Landing - Comparison Section
    landing_comparison_badge: "COMPARATIVA",
    landing_comparison_title: "¿Por qué elegir",
    landing_comparison_highlight: "Sally Better?",
    landing_comparison_desc: "Compara nuestro servicio integral con proveedores tradicionales de impresión",
    landing_traditional_providers: "Proveedores de Impresión Tradicional",
    landing_our_service: "Nuestro Servicio Integral",
    landing_print_digital_control: "IMPRESIÓN + DIGITAL + CONTROL",
    landing_menus_printed_size: "menús impresos 11x17",
    landing_graphic_design_included: "Diseño gráfico incluido",
    landing_brand_adaptation: "Adaptación a marca",
    landing_digital_update_system: "Sistema de actualización digital",
    landing_price_change_access: "Acceso para cambiar precios",
    landing_seasonal_included: "Cambios de temporada incluidos",
    landing_personalized_support: "Administración personalizada/soporte",
    landing_digital_menu_included: "Menú digital incluido",
    landing_yes: "Sí",
    landing_no: "No",
    landing_according_plan: "según plan",
    landing_plan_1000_plus: "plan 1000+",
    landing_elite_available: "Plan elite disponible",
    landing_more_than_1000: "Más de 1,000 menús",
    landing_contact_for_pricing: "Contáctenos para precios",
    landing_not_enough_print: "No basta con imprimir.",
    landing_with_our_service: "Con nuestro servicio usted obtiene",
    landing_control_flexibility: "Control, Flexibilidad y Tecnología",
    landing_for_your_restaurant: "para su restaurante.",
    
    // Landing - Why Choose Us
    landing_why_choose: "¿Por qué elegirnos?",
    landing_fast: "Rápido",
    landing_easy: "Fácil",
    landing_professional: "Profesional",
    landing_quality: "Calidad",
    landing_savings: "Ahorro",
    landing_keep_updated: "Mantén tu menú actualizado sin complicaciones.",
    landing_max_presence: "Máxima presencia. Máximo Control.",
    landing_request_consultation: "Agenda tu Consulta Gratuita",
    
    // Landing - Services Showcase
    landing_services_badge: "NUESTROS SERVICIOS",
    landing_services_title: "Impresión Profesional",
    landing_services_highlight: "+ Cartelería Digital",
    landing_services_desc: "Soluciones completas para la imagen de tu restaurante. Desde menús impresos de alta calidad hasta pantallas digitales actualizables en tiempo real.",
    landing_print_menus_title: "Menús Impresos",
    landing_print_menus_desc: "Impresiones de alta calidad en papel glossy, doble lado. Diseño profesional que refleja la identidad de tu marca con código QR integrado.",
    landing_glossy_finish: "Acabado Glossy",
    landing_digital_signage_title: "Cartelería Digital",
    landing_digital_signage_desc: "Pantallas digitales para tu restaurante. Actualiza precios, productos y promociones en tiempo real desde cualquier dispositivo.",
    landing_realtime_updates: "Actualización en Tiempo Real",
    landing_mobile_control: "Control desde Celular",
    landing_auto_refresh: "Auto-Refresh",
  },
  en: {
    // General
    appName: "SALLY | Better Menú",
    loading: "Loading...",
    
    // Auth
    login: "Login",
    register: "Sign Up",
    email: "Email",
    password: "Password",
    name: "Name",
    welcomeBack: "Welcome back!",
    loginDescription: "Enter your credentials to access your menus",
    createAccount: "Create account",
    alreadyHaveAccount: "Already have an account",
    
    // Dashboard
    myMenus: "My Menus",
    manageMenus: "Manage your digital menus",
    newMenu: "New Menu",
    createMenu: "Create Menu",
    menuName: "Menu name",
    creating: "Creating...",
    cancel: "Cancel",
    hello: "Hello",
    mobileLink: "Mobile Link",
    language: "Language",
    logout: "Logout",
    noMenusYet: "No menus yet",
    createFirstMenu: "Create your first menu to get started",
    edit: "Edit",
    items: "items",
    updated: "Updated",
    template: "Template",
    selectTemplate: "Select a template to get started",
    copyPublicLink: "Copy public link",
    generateQR: "Generate QR code",
    openPublicLink: "Open public link",
    deleteMenu: "Delete menu",
    duplicateMenu: "Duplicate menu",
    menuDuplicated: "Menu duplicated",
    
    // Locations
    locations: "Locations",
    newLocation: "New Location",
    createLocation: "Create Location",
    locationName: "Location name",
    address: "Address",
    description: "Description",
    noLocationsYet: "No locations yet",
    createFirstLocation: "Create your first location",
    allMenus: "All Menus",
    menusInLocation: "Menus in this location",
    noMenusInLocation: "No menus in this location",
    locationCreated: "Location created",
    locationDeleted: "Location deleted",
    deleteLocation: "Delete location",
    editLocation: "Edit location",
    confirmDeleteLocation: "Delete location",
    confirmDeleteLocationDesc: "Are you sure you want to delete",
    deleteLocationWarning: "Menus associated with this location will be unlinked but not deleted.",
    delete: "Delete",
    moveMenu: "Move menu",
    moveMenuDescription: "Select new location for",
    selectNewLocation: "New location",
    noLocation: "No location",
    move: "Move",
    menuMoved: "Menu moved",
    
    // QR Dialog
    qrCode: "QR Code",
    scanToView: "Scan to view the public menu",
    copyLink: "Copy link",
    downloadQR: "Download QR",
    
    // Editor
    back: "Back",
    save: "Save",
    saving: "Saving...",
    preview: "Preview",
    addText: "Text",
    addImage: "Image",
    addShape: "Shape",
    textType: "Type",
    textName: "Name",
    textPrice: "Price",
    image: "Image",
    textContent: "Content",
    add: "Add",
    uploadImage: "Upload image",
    uploadBackground: "Background",
    configuration: "Settings",
    selectImage: "Select image",
    imageAdded: "Image added",
    noBackground: "Upload a background image to start",
    
    // Layers
    layers: "Layers",
    bringToFront: "Bring to front",
    sendToBack: "Send to back",
    bringForward: "Bring forward",
    sendBackward: "Send backward",
    layer: "Layer",
    
    // Canvas settings
    configureCanvasSize: "Configure Canvas",
    presets: "Presets",
    custom: "Custom",
    width: "Width",
    height: "Height",
    aspectRatio: "Aspect Ratio",
    refreshInterval: "Refresh interval (sec)",
    refreshDescription: "Refresh frequency for public view",
    apply: "Apply",
    
    // Properties panel
    properties: "Properties",
    text: "Text",
    label: "Label",
    labelPlaceholder: "Ex: Pizza Margherita...",
    labelHint: "Shows in mobile list",
    textShadow: "Shadow",
    shadowHint: "Improves readability",
    font: "Font",
    fontSize: "Size",
    fontWeight: "Weight",
    color: "Color",
    position: "Position",
    size: "Size",
    opacity: "Opacity",
    deleteItem: "Delete",
    
    // Menu items list
    menuItems: "Elements",
    noItemsYet: "No elements yet",
    selectItemOnCanvas: "Select an item on the canvas to edit its properties",
    
    // Toolbar
    selectMode: "Select",
    panMode: "Pan view",
    undo: "Undo",
    redo: "Redo",
    cut: "Cut",
    copy: "Copy",
    paste: "Paste",
    
    // Mobile
    mobileEdit: "Mobile Edit",
    selectMenu: "Select a menu",
    searchPlaceholder: "Search...",
    noResults: "No results",
    tryAnotherSearch: "Try another search",
    clearSearch: "Clear",
    noTextsInMenu: "No texts",
    addTextsFromDesktop: "Add from desktop editor",
    changesReflected: "Changes will appear in public view after saving",
    
    // Toasts
    menuCreated: "Menu created",
    menuDeleted: "Menu deleted",
    menuSaved: "Menu saved",
    linkCopied: "Link copied",
    mobileLinkCopied: "Mobile link copied",
    qrDownloaded: "QR downloaded",
    nameUpdated: "Name updated",
    configUpdated: "Settings updated",
    textCopied: "Copied",
    textCut: "Cut",
    textPasted: "Pasted",
    changeUndone: "Undone",
    changeRedone: "Redone",
    itemDeleted: "Deleted",
    itemAdded: "Added",
    imageUploaded: "Image uploaded",
    export: "Export",
    exportPNG: "Export as PNG",
    exportJPG: "Export as JPG",
    imageExported: "Image exported",
    
    // Admin
    adminPanel: "Admin Panel",
    adminAccessRequired: "Admin access required",
    userManagement: "User Management",
    manageAllUsers: "Manage all system users",
    addUser: "Add User",
    editUser: "Edit User",
    addUserDesc: "Create a new user account",
    editUserDesc: "Modify user information",
    searchUsers: "Search users...",
    totalUsers: "Total Users",
    activeUsers: "Active Users",
    totalMenus: "Total Menus",
    totalLocations: "Total Locations",
    role: "Role",
    status: "Status",
    created: "Created",
    actions: "Actions",
    active: "Active",
    inactive: "Inactive",
    activate: "Activate",
    deactivate: "Deactivate",
    userCreated: "User created",
    userUpdated: "User updated",
    userDeleted: "User deleted",
    userActivated: "User activated",
    userDeactivated: "User deactivated",
    confirmDeleteUser: "Delete user",
    confirmDeleteUserDesc: "Are you sure you want to delete user",
    deleteUserWarning: "All menus and locations associated with this user will be deleted.",
    fillAllFields: "Fill in all fields",
    passwordRequired: "Password is required",
    leaveBlank: "leave blank to keep",
    accountActive: "Account active",
    noUsersYet: "No users yet",
    create: "Create",
    
    // Suspension
    suspended: "Suspended",
    suspendService: "Suspend service",
    suspendServiceDesc: "Suspend service for",
    suspensionMessage: "Suspension message",
    suspensionMessagePlaceholder: "This service is temporarily suspended...",
    suspensionMessageHelp: "This message will be shown on all public menus of this user.",
    suspend: "Suspend",
    userSuspended: "Service suspended",
    reactivateService: "Reactivate service",
    serviceReactivated: "Service reactivated",
    
    // Stats detail dialogs
    clickToViewAll: "Click to view all",
    allMenus: "All Menus",
    allMenusDesc: "List of all system menus",
    searchMenus: "Search menus...",
    owner: "Owner",
    viewPublic: "View public",
    allLocations: "All Locations",
    allLocationsDesc: "List of all system locations",
    searchLocations: "Search locations...",
    menus: "menus",
    noResults: "No results",
    noLocationsYet: "No locations yet",
    
    // Dashboard - Slideshows
    slideshows: "Slideshows",
    slideshowsDesc: "Group multiple menus in a rotating presentation",
    newSlideshow: "New Slideshow",
    editSlideshow: "Edit Slideshow",
    schedule: "Schedule",
    configureSchedule: "Configure Schedule",
    saveSchedule: "Save Schedule",
    createSlideshow: "Create Slideshow",
    createSlideshowDesc: "Configure a presentation with multiple menus",
    slideshowName: "Slideshow Name",
    locationOptional: "Location (optional)",
    transitionEffect: "Transition Effect",
    fade: "Fade",
    slide: "Slide",
    noTransition: "No transition",
    availableMenus: "Available menus",
    menusInSlideshow: "Menus in slideshow",
    scanToViewSlideshow: "Scan to view slideshow",
    addMenus: "Add menus",
    modifySlideshowConfig: "Modify slideshow configuration",
    noMenusAvailable: "No menus available",
    selectLocation: "Select location",
    allLocations: "All locations",
    
    // Dashboard - Calendars
    calendars: "Calendars",
    newCalendar: "New Calendar",
    calendarName: "Calendar name",
    timezone: "Timezone",
    autoDetected: "auto-detected",
    defaultContent: "Default content",
    weeklySchedule: "Weekly schedule",
    dateExceptions: "Date exceptions",
    addException: "Add exception",
    noScheduleForDay: "No content scheduled for this day",
    publicLink: "Public link",
    confirmTimezone: "Is this timezone correct?",
    
    // Landing Page
    landing_hero_badge: "Digital Menu Platform #1",
    landing_hero_title: "Transform your menu into a",
    landing_hero_title_highlight: "digital experience",
    landing_hero_description: "Create stunning digital menus for your restaurant, café or bar. Update prices, add promotions and schedule content automatically.",
    landing_hero_email_placeholder: "Your email address",
    landing_hero_request_demo: "Request Demo",
    landing_hero_no_credit: "No credit card required",
    landing_hero_setup_minutes: "Setup in minutes",
    landing_hero_support_included: "Support included",
    landing_features_badge: "FEATURES",
    landing_features_title: "Everything you need to",
    landing_features_highlight: "shine",
    landing_features_desc: "Powerful and easy-to-use tools to create digital menus that captivate your customers",
    landing_usecases_badge: "USE CASES",
    landing_usecases_title: "Perfect for your",
    landing_usecases_highlight: "business",
    landing_usecases_desc: "Designed for restaurants, cafés, bars and any establishment looking to modernize their menu",
    landing_pricing_badge: "PRICING",
    landing_pricing_title: "Plans for every",
    landing_pricing_highlight: "need",
    landing_pricing_desc: "Start and scale when you need it. No commitments, cancel anytime.",
    landing_cta_title: "Ready to transform your menu?",
    landing_cta_desc: "Join hundreds of restaurants already using Sally Better to create unique digital experiences for their customers.",
    landing_start_now: "Start Now",
    landing_view_demo: "View Demo",
    landing_feature_editor: "Visual Drag & Drop Editor",
    landing_feature_editor_desc: "Design professional menus without technical knowledge. Drag and drop elements easily.",
    landing_feature_calendar: "Calendar Scheduling",
    landing_feature_calendar_desc: "Automatically schedule which menu to show based on day and time. Breakfast, lunch, dinner.",
    landing_feature_timezone: "Multiple Time Zones",
    landing_feature_timezone_desc: "Manage restaurants in different cities with independent time zones.",
    landing_feature_widgets: "Dynamic Widgets",
    landing_feature_widgets_desc: "Add digital clock, weather forecast, RSS news and animated text.",
    landing_feature_slideshows: "Automatic Slideshows",
    landing_feature_slideshows_desc: "Create rotating presentations of multiple menus with smooth transitions.",
    landing_feature_qr: "Unique QR Codes",
    landing_feature_qr_desc: "Generate QR codes for each menu. Your customers scan and see the updated menu.",
    landing_feature_videos: "Videos and Images",
    landing_feature_videos_desc: "Supports YouTube, Vimeo videos and direct files for more attractive menus.",
    landing_feature_shapes: "Shapes and Animations",
    landing_feature_shapes_desc: "Add geometric shapes and entry animations to capture attention.",
    landing_usecase_restaurants: "Restaurants",
    landing_usecase_restaurants_desc: "Digital menus that update instantly. Change prices, add daily specials and promotions in seconds.",
    landing_usecase_cafes: "Cafés",
    landing_usecase_cafes_desc: "Show your coffee menu, pastries and morning promotions. Schedule breakfast menus automatically.",
    landing_usecase_bars: "Bars",
    landing_usecase_bars_desc: "Drink menu, happy hour and special events. Update prices and night promotions instantly.",
    landing_plan_basic: "Basic",
    landing_plan_basic_desc: "Perfect to get started",
    landing_plan_pro: "Professional",
    landing_plan_pro_desc: "For growing restaurants",
    landing_plan_enterprise: "Enterprise",
    landing_plan_enterprise_desc: "For chains and franchises",
    landing_most_popular: "Most Popular",
    landing_contact_sales: "Contact Sales",
    landing_per_month: "/month",
    landing_custom: "Custom",
    landing_contact_form_title: "Fill in your details and we'll contact you soon",
    landing_full_name: "Full name",
    landing_phone: "Phone",
    landing_business_name: "Business name",
    landing_message: "Message (optional)",
    landing_message_placeholder: "Tell us more about your needs...",
    landing_send_request: "Send Request",
    landing_sending: "Sending...",
    landing_message_sent: "Message sent! We'll contact you soon.",
    landing_message_error: "Error sending message. Please try again.",
    landing_fill_required: "Please fill in name and email",
    
    // Landing - New Print + Digital Plans
    landing_plan_250: "Plan 250",
    landing_plan_250_price: "$165",
    landing_plan_250_desc: "Ideal for small or growing restaurants",
    landing_plan_500: "Plan 500",
    landing_plan_500_price: "$325",
    landing_plan_500_desc: "For established restaurants",
    landing_plan_1000: "Plan 1000",
    landing_plan_1000_price: "$650",
    landing_plan_1000_desc: "Maximum control and presence",
    landing_premium: "PREMIUM",
    
    // Plan features
    landing_menus_printed: "printed menus",
    landing_double_sided_glossy: "double-sided (glossy)",
    landing_print_digital_design: "Print and Digital Menu Design",
    landing_unlimited_changes: "Add products and price changes without limits",
    landing_digital_panel_access: "Access to Digital Menu control panel",
    landing_seasonal_changes: "seasonal design change",
    landing_seasonal_changes_plural: "seasonal design changes",
    landing_menu_with_qr: "Menu with QR Code",
    landing_personalized_admin: "Personalized Digital Menu management",
    landing_priority_support: "Priority support",
    landing_includes_plan: "Plan Features",
    
    // Landing - All in One Section
    landing_allinone_badge: "THE ALL-IN-ONE SOLUTION",
    landing_allinone_title: "Professional Menu",
    landing_allinone_highlight: "Print + Digital",
    landing_allinone_desc: "One monthly payment, total control and professional image for your restaurant",
    landing_allinone_feature1: "Professional Graphic Design",
    landing_allinone_feature2: "High-quality printing and materials",
    landing_allinone_feature3: "Unlimited price and product changes",
    landing_allinone_feature4: "Seasonal menu design",
    landing_allinone_feature5: "Menu with QR Code",
    landing_allinone_feature6: "Digital menu for screens, accessible from laptop, tablet or phone",
    
    // Landing - Problems Section
    landing_problems_title: "Is your menu outdated?",
    landing_problem1: "Expensive design changes",
    landing_problem2: "Reprint when you change prices or add new products",
    landing_problem3: "Same design every year",
    landing_problem4: "Screens not updated",
    landing_problems_quote: "Your restaurant constantly changes.",
    landing_problems_quote2: "Your menu should too.",
    
    // Landing - Comparison Section
    landing_comparison_badge: "COMPARISON",
    landing_comparison_title: "Why choose",
    landing_comparison_highlight: "Sally Better?",
    landing_comparison_desc: "Compare our comprehensive service with traditional print providers",
    landing_traditional_providers: "Traditional Print Providers",
    landing_our_service: "Our Comprehensive Service",
    landing_print_digital_control: "PRINT + DIGITAL + CONTROL",
    landing_menus_printed_size: "printed menus 11x17",
    landing_graphic_design_included: "Graphic design included",
    landing_brand_adaptation: "Brand adaptation",
    landing_digital_update_system: "Digital update system",
    landing_price_change_access: "Access to change prices",
    landing_seasonal_included: "Seasonal changes included",
    landing_personalized_support: "Personalized management/support",
    landing_digital_menu_included: "Digital menu included",
    landing_yes: "Yes",
    landing_no: "No",
    landing_according_plan: "per plan",
    landing_plan_1000_plus: "plan 1000+",
    landing_elite_available: "Elite plan available",
    landing_more_than_1000: "More than 1,000 menus",
    landing_contact_for_pricing: "Contact us for pricing",
    landing_not_enough_print: "Printing is not enough.",
    landing_with_our_service: "With our service you get",
    landing_control_flexibility: "Control, Flexibility and Technology",
    landing_for_your_restaurant: "for your restaurant.",
    
    // Landing - Why Choose Us
    landing_why_choose: "Why choose us?",
    landing_fast: "Fast",
    landing_easy: "Easy",
    landing_professional: "Professional",
    landing_quality: "Quality",
    landing_savings: "Savings",
    landing_keep_updated: "Keep your menu updated without complications.",
    landing_max_presence: "Maximum presence. Maximum Control.",
    landing_request_consultation: "Schedule your Free Consultation",
    
    // Landing - Services Showcase
    landing_services_badge: "OUR SERVICES",
    landing_services_title: "Professional Printing",
    landing_services_highlight: "+ Digital Signage",
    landing_services_desc: "Complete solutions for your restaurant's image. From high-quality printed menus to real-time updatable digital screens.",
    landing_print_menus_title: "Printed Menus",
    landing_print_menus_desc: "High-quality prints on glossy paper, double-sided. Professional design that reflects your brand identity with integrated QR code.",
    landing_glossy_finish: "Glossy Finish",
    landing_digital_signage_title: "Digital Signage",
    landing_digital_signage_desc: "Digital screens for your restaurant. Update prices, products and promotions in real-time from any device.",
    landing_realtime_updates: "Real-time Updates",
    landing_mobile_control: "Mobile Control",
    landing_auto_refresh: "Auto-Refresh",
  },
  pt: {
    // General
    appName: "SALLY | Better Menú",
    loading: "Carregando...",
    
    // Auth
    login: "Entrar",
    register: "Criar Conta",
    email: "E-mail",
    password: "Senha",
    name: "Nome",
    welcomeBack: "Bem-vindo de volta!",
    loginDescription: "Digite suas credenciais",
    createAccount: "Criar conta",
    alreadyHaveAccount: "Já tenho conta",
    
    // Dashboard
    myMenus: "Meus Menus",
    manageMenus: "Gerencie seus menus digitais",
    newMenu: "Novo Menu",
    createMenu: "Criar Menu",
    menuName: "Nome do menu",
    creating: "Criando...",
    cancel: "Cancelar",
    hello: "Olá",
    mobileLink: "Link Móvel",
    language: "Idioma",
    logout: "Sair",
    noMenusYet: "Sem menus ainda",
    createFirstMenu: "Crie seu primeiro menu",
    edit: "Editar",
    items: "itens",
    updated: "Atualizado",
    template: "Modelo",
    selectTemplate: "Selecione um modelo para começar",
    copyPublicLink: "Copiar link público",
    generateQR: "Gerar código QR",
    openPublicLink: "Abrir link público",
    deleteMenu: "Excluir menu",
    duplicateMenu: "Duplicar menu",
    menuDuplicated: "Menu duplicado",
    
    // Locations
    locations: "Localizações",
    newLocation: "Nova Localização",
    createLocation: "Criar Localização",
    locationName: "Nome da localização",
    address: "Endereço",
    description: "Descrição",
    noLocationsYet: "Sem localizações",
    createFirstLocation: "Crie sua primeira localização",
    allMenus: "Todos os Menus",
    menusInLocation: "Menus nesta localização",
    noMenusInLocation: "Sem menus nesta localização",
    locationCreated: "Localização criada",
    locationDeleted: "Localização excluída",
    deleteLocation: "Excluir localização",
    editLocation: "Editar localização",
    confirmDeleteLocation: "Excluir localização",
    confirmDeleteLocationDesc: "Tem certeza que deseja excluir",
    deleteLocationWarning: "Os menus associados a esta localização serão desvinculados mas não excluídos.",
    delete: "Excluir",
    moveMenu: "Mover menu",
    moveMenuDescription: "Selecione a nova localização para",
    selectNewLocation: "Nova localização",
    noLocation: "Sem localização",
    move: "Mover",
    menuMoved: "Menu movido",
    
    // Dashboard - Slideshows
    slideshows: "Slideshows",
    slideshowsDesc: "Agrupe vários menus em uma apresentação rotativa",
    newSlideshow: "Novo Slideshow",
    editSlideshow: "Editar Slideshow",
    schedule: "Horário",
    configureSchedule: "Configurar Horário",
    saveSchedule: "Salvar Horário",
    createSlideshow: "Criar Slideshow",
    createSlideshowDesc: "Configure uma apresentação com múltiplos menus",
    slideshowName: "Nome do Slideshow",
    locationOptional: "Localização (opcional)",
    transitionEffect: "Efeito de Transição",
    fade: "Fade (Desvanecer)",
    slide: "Slide (Deslizar)",
    noTransition: "Sem transição",
    availableMenus: "Menus disponíveis",
    menusInSlideshow: "Menus no slideshow",
    scanToViewSlideshow: "Escaneie para ver o slideshow",
    addMenus: "Adicionar menus",
    modifySlideshowConfig: "Modifica a configuração do slideshow",
    noMenusAvailable: "Não há menus disponíveis",
    selectLocation: "Selecionar localização",
    allLocations: "Todas as localizações",
    noSlideshowsYet: "Você ainda não tem slideshows",
    createFirstSlideshow: "Criar primeiro slideshow",
    globalDuration: "Duração Global (segundos)",
    selectMenusToAdd: "Selecione menus acima para adicioná-los",
    noMoreMenusAvailable: "Não há mais menus disponíveis",
    
    // Dashboard - Calendars
    calendars: "Calendários",
    calendarsDesc: "Programe qual menu ou slideshow mostrar por dia e hora",
    newCalendar: "Novo Calendário",
    calendarName: "Nome do calendário",
    timezone: "Fuso horário",
    autoDetected: "detectado automaticamente",
    defaultContent: "Conteúdo padrão",
    weeklySchedule: "Programação semanal",
    dateExceptions: "Exceções de data",
    addException: "Adicionar exceção",
    noScheduleForDay: "Sem conteúdo programado para este dia",
    publicLink: "Link público",
    confirmTimezone: "O fuso horário está correto?",
    
    // QR Dialog
    qrCode: "Código QR",
    scanToView: "Escaneie para ver o menu",
    copyLink: "Copiar link",
    downloadQR: "Baixar QR",
    
    // Editor
    back: "Voltar",
    save: "Salvar",
    saving: "Salvando...",
    preview: "Pré-visualização",
    addText: "Texto",
    addImage: "Imagem",
    addShape: "Forma",
    textType: "Tipo",
    textName: "Nome",
    textPrice: "Preço",
    image: "Imagem",
    textContent: "Conteúdo",
    add: "Adicionar",
    uploadImage: "Enviar imagem",
    uploadBackground: "Fundo",
    configuration: "Configuração",
    selectImage: "Selecionar imagem",
    imageAdded: "Imagem adicionada",
    noBackground: "Envie uma imagem de fundo",
    
    // Layers
    layers: "Camadas",
    bringToFront: "Trazer para frente",
    sendToBack: "Enviar para trás",
    bringForward: "Subir camada",
    sendBackward: "Descer camada",
    layer: "Camada",
    
    // Canvas settings
    configureCanvasSize: "Configurar Canvas",
    presets: "Predefinições",
    custom: "Personalizado",
    width: "Largura",
    height: "Altura",
    aspectRatio: "Proporção",
    refreshInterval: "Intervalo de atualização (seg)",
    refreshDescription: "Frequência de atualização",
    apply: "Aplicar",
    
    // Properties panel
    properties: "Propriedades",
    text: "Texto",
    label: "Rótulo",
    labelPlaceholder: "Ex: Pizza Margherita...",
    labelHint: "Aparece na lista móvel",
    textShadow: "Sombra",
    shadowHint: "Melhora legibilidade",
    font: "Fonte",
    fontSize: "Tamanho",
    fontWeight: "Peso",
    color: "Cor",
    position: "Posição",
    size: "Tamanho",
    opacity: "Opacidade",
    deleteItem: "Excluir",
    
    // Menu items list
    menuItems: "Elementos",
    noItemsYet: "Sem elementos",
    selectItemOnCanvas: "Selecione um item no canvas para editar suas propriedades",
    
    // Toolbar
    selectMode: "Seleção",
    panMode: "Mover vista",
    undo: "Desfazer",
    redo: "Refazer",
    cut: "Cortar",
    copy: "Copiar",
    paste: "Colar",
    
    // Mobile
    mobileEdit: "Edição Móvel",
    selectMenu: "Selecione um menu",
    searchPlaceholder: "Buscar...",
    noResults: "Sem resultados",
    tryAnotherSearch: "Tente outra busca",
    clearSearch: "Limpar",
    noTextsInMenu: "Sem textos",
    addTextsFromDesktop: "Adicione pelo editor",
    changesReflected: "Alterações aparecerão ao salvar",
    
    // Toasts
    menuCreated: "Menu criado",
    menuDeleted: "Menu excluído",
    menuSaved: "Menu salvo",
    linkCopied: "Link copiado",
    mobileLinkCopied: "Link móvel copiado",
    qrDownloaded: "QR baixado",
    nameUpdated: "Nome atualizado",
    configUpdated: "Configuração atualizada",
    textCopied: "Copiado",
    textCut: "Cortado",
    textPasted: "Colado",
    changeUndone: "Desfeito",
    changeRedone: "Refeito",
    itemDeleted: "Excluído",
    itemAdded: "Adicionado",
    imageUploaded: "Imagem enviada",
    export: "Exportar",
    exportPNG: "Exportar como PNG",
    exportJPG: "Exportar como JPG",
    imageExported: "Imagem exportada",
    
    // Admin
    adminPanel: "Painel de Administração",
    adminAccessRequired: "Acesso de administrador requerido",
    userManagement: "Gestão de Usuários",
    manageAllUsers: "Gerencie todos os usuários do sistema",
    addUser: "Adicionar Usuário",
    editUser: "Editar Usuário",
    addUserDesc: "Criar uma nova conta de usuário",
    editUserDesc: "Modificar informações do usuário",
    searchUsers: "Buscar usuários...",
    totalUsers: "Total Usuários",
    activeUsers: "Usuários Ativos",
    totalMenus: "Total Menus",
    totalLocations: "Total Localizações",
    role: "Função",
    status: "Status",
    created: "Criado",
    actions: "Ações",
    active: "Ativo",
    inactive: "Inativo",
    activate: "Ativar",
    deactivate: "Desativar",
    userCreated: "Usuário criado",
    userUpdated: "Usuário atualizado",
    userDeleted: "Usuário excluído",
    userActivated: "Usuário ativado",
    userDeactivated: "Usuário desativado",
    confirmDeleteUser: "Excluir usuário",
    confirmDeleteUserDesc: "Tem certeza que deseja excluir o usuário",
    deleteUserWarning: "Todos os menus e localizações associados a este usuário serão excluídos.",
    fillAllFields: "Preencha todos os campos",
    passwordRequired: "Senha é obrigatória",
    leaveBlank: "deixe vazio para manter",
    accountActive: "Conta ativa",
    noUsersYet: "Nenhum usuário ainda",
    create: "Criar",
    
    // Suspension
    suspended: "Suspenso",
    suspendService: "Suspender serviço",
    suspendServiceDesc: "Suspender serviço de",
    suspensionMessage: "Mensagem de suspensão",
    suspensionMessagePlaceholder: "Este serviço está temporariamente suspenso...",
    suspensionMessageHelp: "Esta mensagem será exibida em todos os menus públicos deste usuário.",
    suspend: "Suspender",
    userSuspended: "Serviço suspenso",
    reactivateService: "Reativar serviço",
    serviceReactivated: "Serviço reativado",
    
    // Stats detail dialogs
    clickToViewAll: "Clique para ver todos",
    allMenus: "Todos os Menus",
    allMenusDesc: "Lista de todos os menus do sistema",
    searchMenus: "Buscar menus...",
    owner: "Proprietário",
    viewPublic: "Ver público",
    allLocations: "Todas as Localizações",
    allLocationsDesc: "Lista de todas as localizações do sistema",
    searchLocations: "Buscar localizações...",
    menus: "menus",
    noResults: "Sem resultados",
    noLocationsYet: "Nenhuma localização ainda",
    
    // Landing Page
    landing_hero_badge: "Plataforma de Menu Digital #1",
    landing_hero_title: "Transforme seu menu em uma",
    landing_hero_title_highlight: "experiência digital",
    landing_hero_description: "Crie menus digitais impressionantes para seu restaurante, café ou bar. Atualize preços, adicione promoções e programe conteúdo automaticamente.",
    landing_hero_email_placeholder: "Seu endereço de email",
    landing_hero_request_demo: "Solicitar Demo",
    landing_hero_no_credit: "Sem cartão de crédito",
    landing_hero_setup_minutes: "Configure em minutos",
    landing_hero_support_included: "Suporte incluído",
    landing_features_badge: "RECURSOS",
    landing_features_title: "Tudo que você precisa para",
    landing_features_highlight: "brilhar",
    landing_features_desc: "Ferramentas poderosas e fáceis de usar para criar menus digitais que cativam seus clientes",
    landing_usecases_badge: "CASOS DE USO",
    landing_usecases_title: "Perfeito para o seu",
    landing_usecases_highlight: "negócio",
    landing_usecases_desc: "Projetado para restaurantes, cafés, bares e qualquer estabelecimento que queira modernizar seu cardápio",
    landing_start_now: "Começar Agora",
    landing_view_demo: "Ver Demo",
    landing_pricing_badge: "PREÇOS",
    landing_pricing_title: "Planos para cada",
    landing_pricing_highlight: "necessidade",
    landing_pricing_desc: "Comece e escale quando precisar. Sem compromissos, cancele quando quiser.",
    landing_most_popular: "Mais Popular",
    landing_cta_title: "Pronto para transformar seu menu?",
    landing_cta_desc: "Junte-se a centenas de restaurantes que já estão usando Sally Better para criar experiências digitais únicas para seus clientes.",
    landing_contact_sales: "Contatar Vendas",
    landing_feature_editor: "Editor Visual Arrastar e Soltar",
    landing_feature_editor_desc: "Projete menus profissionais sem conhecimento técnico. Arraste e solte elementos facilmente.",
    landing_feature_calendar: "Programação por Calendário",
    landing_feature_calendar_desc: "Programe automaticamente qual menu exibir com base no dia e hora. Café da manhã, almoço, jantar.",
    landing_feature_timezone: "Múltiplos Fusos Horários",
    landing_feature_timezone_desc: "Gerencie restaurantes em diferentes cidades com fusos horários independentes.",
    landing_feature_widgets: "Widgets Dinâmicos",
    landing_feature_widgets_desc: "Adicione relógio digital, previsão do tempo, notícias RSS e texto animado.",
    landing_feature_slideshows: "Slideshows Automáticos",
    landing_feature_slideshows_desc: "Crie apresentações rotativas de múltiplos menus com transições suaves.",
    landing_feature_qr: "Códigos QR Únicos",
    landing_feature_qr_desc: "Gere códigos QR para cada menu. Seus clientes escaneiam e veem o menu atualizado.",
    landing_feature_videos: "Vídeos e Imagens",
    landing_feature_videos_desc: "Suporta vídeos do YouTube, Vimeo e arquivos diretos para menus mais atrativos.",
    landing_feature_shapes: "Formas e Animações",
    landing_feature_shapes_desc: "Adicione formas geométricas e animações de entrada para captar atenção.",
    landing_usecase_restaurants: "Restaurantes",
    landing_usecase_restaurants_desc: "Menus digitais que se atualizam instantaneamente. Mude preços, adicione pratos do dia e promoções em segundos.",
    landing_usecase_cafes: "Cafés",
    landing_usecase_cafes_desc: "Mostre seu cardápio de cafés, doces e promoções matinais. Programe menus de café da manhã automaticamente.",
    landing_usecase_bars: "Bares",
    landing_usecase_bars_desc: "Cardápio de bebidas, happy hour e eventos especiais. Atualize preços e promoções noturnas instantaneamente.",
    landing_plan_basic: "Básico",
    landing_plan_basic_desc: "Perfeito para começar",
    landing_plan_pro: "Profissional",
    landing_plan_pro_desc: "Para restaurantes em crescimento",
    landing_plan_enterprise: "Empresarial",
    landing_plan_enterprise_desc: "Para redes e franquias",
    landing_per_month: "/mês",
    landing_contact: "Contato",
    landing_fill_required: "Preencha os campos obrigatórios",
    landing_message_sent: "Mensagem enviada com sucesso",
    landing_message_error: "Erro ao enviar mensagem",
    landing_your_name: "Seu nome",
    landing_your_email: "Seu email",
    landing_your_phone: "Telefone (opcional)",
    landing_your_business: "Nome do estabelecimento",
    landing_your_message: "Mensagem (opcional)",
    landing_send: "Enviar",
    landing_sending: "Enviando...",
    
    // Landing - New Print + Digital Plans
    landing_plan_250: "Plano 250",
    landing_plan_250_price: "$165",
    landing_plan_250_desc: "Ideal para restaurantes pequenos ou em crescimento",
    landing_plan_500: "Plano 500",
    landing_plan_500_price: "$325",
    landing_plan_500_desc: "Para restaurantes estabelecidos",
    landing_plan_1000: "Plano 1000",
    landing_plan_1000_price: "$650",
    landing_plan_1000_desc: "Máximo controle e presença",
    landing_premium: "PREMIUM",
    
    // Plan features
    landing_menus_printed: "menus impressos",
    landing_double_sided_glossy: "frente e verso (glossy)",
    landing_print_digital_design: "Design de Menu impresso e Digital",
    landing_unlimited_changes: "Adicione produtos e mudanças de preços sem limites",
    landing_digital_panel_access: "Acesso ao painel de controle do Menu Digital",
    landing_seasonal_changes: "mudança de design por temporada",
    landing_seasonal_changes_plural: "mudanças de design por temporada",
    landing_menu_with_qr: "Menu com Código QR",
    landing_personalized_admin: "Administração personalizada do seu Menu Digital",
    landing_priority_support: "Suporte prioritário",
    landing_includes_plan: "Recursos do Plano",
    
    // Landing - All in One Section
    landing_allinone_badge: "A SOLUÇÃO TUDO EM UM",
    landing_allinone_title: "Menu Profissional",
    landing_allinone_highlight: "Impresso + Digital",
    landing_allinone_desc: "Um único pagamento mensal, controle total e imagem profissional para seu restaurante",
    landing_allinone_feature1: "Design Gráfico Profissional",
    landing_allinone_feature2: "Impressão e materiais de alta qualidade",
    landing_allinone_feature3: "Mudanças de preços e produtos ilimitadas",
    landing_allinone_feature4: "Design de menu por temporada",
    landing_allinone_feature5: "Menu com Código QR",
    landing_allinone_feature6: "Menu digital para telas, com acesso via laptop, tablet ou celular",
    
    // Landing - Problems Section
    landing_problems_title: "Seu menu está desatualizado?",
    landing_problem1: "Mudanças de design caras",
    landing_problem2: "Reimprimir quando muda preços ou adiciona novos produtos",
    landing_problem3: "O mesmo design todos os anos",
    landing_problem4: "Telas sem atualizar",
    landing_problems_quote: "Seu restaurante muda constantemente.",
    landing_problems_quote2: "Seu menu também deveria.",
    
    // Landing - Comparison Section
    landing_comparison_badge: "COMPARATIVO",
    landing_comparison_title: "Por que escolher",
    landing_comparison_highlight: "Sally Better?",
    landing_comparison_desc: "Compare nosso serviço integral com fornecedores tradicionais de impressão",
    landing_traditional_providers: "Fornecedores de Impressão Tradicional",
    landing_our_service: "Nosso Serviço Integral",
    landing_print_digital_control: "IMPRESSÃO + DIGITAL + CONTROLE",
    landing_menus_printed_size: "menus impressos 11x17",
    landing_graphic_design_included: "Design gráfico incluído",
    landing_brand_adaptation: "Adaptação à marca",
    landing_digital_update_system: "Sistema de atualização digital",
    landing_price_change_access: "Acesso para mudar preços",
    landing_seasonal_included: "Mudanças de temporada incluídas",
    landing_personalized_support: "Administração personalizada/suporte",
    landing_digital_menu_included: "Menu digital incluído",
    landing_yes: "Sim",
    landing_no: "Não",
    landing_according_plan: "conforme plano",
    landing_plan_1000_plus: "plano 1000+",
    landing_elite_available: "Plano elite disponível",
    landing_more_than_1000: "Mais de 1.000 menus",
    landing_contact_for_pricing: "Entre em contato para preços",
    landing_not_enough_print: "Não basta imprimir.",
    landing_with_our_service: "Com nosso serviço você obtém",
    landing_control_flexibility: "Controle, Flexibilidade e Tecnologia",
    landing_for_your_restaurant: "para seu restaurante.",
    
    // Landing - Why Choose Us
    landing_why_choose: "Por que nos escolher?",
    landing_fast: "Rápido",
    landing_easy: "Fácil",
    landing_professional: "Profissional",
    landing_quality: "Qualidade",
    landing_savings: "Economia",
    landing_keep_updated: "Mantenha seu menu atualizado sem complicações.",
    landing_max_presence: "Máxima presença. Máximo Controle.",
    landing_request_consultation: "Agende sua Consulta Gratuita",
    
    // Landing - Services Showcase
    landing_services_badge: "NOSSOS SERVIÇOS",
    landing_services_title: "Impressão Profissional",
    landing_services_highlight: "+ Sinalização Digital",
    landing_services_desc: "Soluções completas para a imagem do seu restaurante. De menus impressos de alta qualidade a telas digitais atualizáveis em tempo real.",
    landing_print_menus_title: "Menus Impressos",
    landing_print_menus_desc: "Impressões de alta qualidade em papel glossy, frente e verso. Design profissional que reflete a identidade da sua marca com código QR integrado.",
    landing_glossy_finish: "Acabamento Glossy",
    landing_digital_signage_title: "Sinalização Digital",
    landing_digital_signage_desc: "Telas digitais para seu restaurante. Atualize preços, produtos e promoções em tempo real de qualquer dispositivo.",
    landing_realtime_updates: "Atualização em Tempo Real",
    landing_mobile_control: "Controle pelo Celular",
    landing_auto_refresh: "Auto-Atualização",
  },
  
  // Haitian Creole (Kreyòl)
  ht: {
    // General
    appName: "SALLY | Better Menú",
    loading: "Chajman...",
    
    // Auth
    login: "Konekte",
    register: "Kreye Kont",
    email: "Imèl",
    password: "Modpas",
    name: "Non",
    welcomeBack: "Byenveni ankò!",
    loginDescription: "Antre idantifyan ou pou jwenn meni ou yo",
    createAccount: "Kreye kont",
    alreadyHaveAccount: "Mwen gen yon kont deja",
    
    // Dashboard
    myMenus: "Meni Mwen yo",
    manageMenus: "Jere meni dijital ou yo",
    newMenu: "Nouvo Meni",
    createMenu: "Kreye Meni",
    menuName: "Non meni a",
    creating: "Kreyasyon...",
    cancel: "Anile",
    hello: "Bonjou",
    mobileLink: "Lyen Mobil",
    language: "Lang",
    logout: "Sòti",
    noMenusYet: "Ou pa gen meni ankò",
    createFirstMenu: "Kreye premye meni ou pou kòmanse",
    edit: "Modifye",
    items: "eleman yo",
    updated: "Mete ajou",
    template: "Modèl",
    selectTemplate: "Chwazi yon modèl pou kòmanse",
    copyPublicLink: "Kopye lyen piblik",
    generateQR: "Jenere kòd QR",
    openPublicLink: "Louvri lyen piblik",
    deleteMenu: "Efase meni",
    duplicateMenu: "Kopi meni",
    menuDuplicated: "Meni kopye",
    
    // Locations
    locations: "Kote yo",
    newLocation: "Nouvo Kote",
    createLocation: "Kreye Kote",
    locationName: "Non kote a",
    address: "Adrès",
    description: "Deskripsyon",
    noLocationsYet: "Pa gen kote ankò",
    createFirstLocation: "Kreye premye kote ou",
    allMenus: "Tout Meni yo",
    menusInLocation: "Meni nan kote sa a",
    noMenusInLocation: "Pa gen meni nan kote sa a",
    locationCreated: "Kote kreye",
    locationDeleted: "Kote efase",
    deleteLocation: "Efase kote",
    editLocation: "Modifye kote",
    confirmDeleteLocation: "Efase kote",
    confirmDeleteLocationDesc: "Ou sèten ou vle efase",
    deleteLocationWarning: "Meni yo ki asosye ak kote sa a pral dekonekte men yo pa pral efase.",
    delete: "Efase",
    moveMenu: "Deplase meni",
    moveMenuDescription: "Chwazi nouvo kote pou",
    selectNewLocation: "Nouvo kote",
    noLocation: "San kote",
    move: "Deplase",
    menuMoved: "Meni deplase",
    
    // Dashboard - Slideshows
    slideshows: "Slideshow yo",
    slideshowsDesc: "Gwoup plizyè meni nan yon prezantasyon wotasyon",
    newSlideshow: "Nouvo Slideshow",
    editSlideshow: "Modifye Slideshow",
    schedule: "Orè",
    configureSchedule: "Konfigire Orè",
    saveSchedule: "Anrejistre Orè",
    createSlideshow: "Kreye Slideshow",
    createSlideshowDesc: "Konfigire yon prezantasyon ak plizyè meni",
    slideshowName: "Non Slideshow la",
    locationOptional: "Kote (opsyonèl)",
    transitionEffect: "Efè Tranzisyon",
    fade: "Fade (Disparisyon)",
    slide: "Glise",
    noTransition: "San tranzisyon",
    availableMenus: "Meni ki disponib",
    menusInSlideshow: "Meni nan slideshow la",
    scanToViewSlideshow: "Eskane pou wè slideshow la",
    addMenus: "Ajoute meni",
    modifySlideshowConfig: "Modifye konfigirasyon slideshow la",
    noMenusAvailable: "Pa gen meni disponib",
    selectLocation: "Chwazi kote",
    allLocations: "Tout kote yo",
    noSlideshowsYet: "Ou poko gen slideshow",
    createFirstSlideshow: "Kreye premye slideshow",
    globalDuration: "Dire Global (segonn)",
    selectMenusToAdd: "Chwazi meni anlè pou ajoute yo",
    noMoreMenusAvailable: "Pa gen plis meni disponib",
    
    // Dashboard - Calendars
    calendars: "Kalandriye yo",
    calendarsDesc: "Pwograme ki meni oswa slideshow pou montre pa jou ak lè",
    newCalendar: "Nouvo Kalandriye",
    calendarName: "Non kalandriye a",
    timezone: "Zòn lè",
    autoDetected: "detekte otomatikman",
    defaultContent: "Kontni pa defo",
    weeklySchedule: "Pwogramasyon semèn",
    dateExceptions: "Eksepsyon dat",
    addException: "Ajoute eksepsyon",
    noScheduleForDay: "Pa gen kontni pwograme pou jou sa a",
    publicLink: "Lyen piblik",
    confirmTimezone: "Zòn lè a kòrèk?",
    
    // QR Dialog
    qrCode: "Kòd QR",
    scanToView: "Eskane pou wè meni a",
    copyLink: "Kopye lyen",
    downloadQR: "Telechaje QR",
    
    // Editor
    back: "Retounen",
    save: "Anrejistre",
    saving: "Anrejistreman...",
    preview: "Apersi",
    addText: "Tèks",
    addImage: "Imaj",
    addShape: "Fòm",
    textType: "Tip",
    textName: "Non",
    textPrice: "Pri",
    image: "Imaj",
    textContent: "Kontni",
    add: "Ajoute",
    uploadImage: "Voye imaj",
    uploadBackground: "Fon",
    configuration: "Konfigirasyon",
    selectImage: "Chwazi imaj",
    imageAdded: "Imaj ajoute",
    noBackground: "Voye yon imaj fon",
    
    // Layers
    layers: "Kouch yo",
    bringToFront: "Mete devan",
    sendToBack: "Voye dèyè",
    bringForward: "Monte kouch",
    sendBackward: "Desann kouch",
    layer: "Kouch",
    
    // Canvas settings
    configureCanvasSize: "Konfigire Canvas",
    presets: "Predefinisyon",
    custom: "Pèsonalize",
    width: "Lajè",
    height: "Wotè",
    aspectRatio: "Pwopòsyon",
    refreshInterval: "Entèval aktyalizasyon (sek)",
    refreshDescription: "Frekans aktyalizasyon",
    apply: "Aplike",
    
    // Properties panel
    properties: "Pwopriyete yo",
    text: "Tèks",
    label: "Etikèt",
    labelPlaceholder: "Egz: Pizza Margherita...",
    labelHint: "Parèt nan lis mobil la",
    textShadow: "Lonbraj",
    shadowHint: "Amelyore lizibilite",
    font: "Polis",
    fontSize: "Gwosè",
    fontWeight: "Pwa",
    color: "Koulè",
    position: "Pozisyon",
    size: "Gwosè",
    opacity: "Opasite",
    deleteItem: "Efase",
    
    // Menu items list
    menuItems: "Eleman yo",
    noItemsYet: "Pa gen eleman ankò",
    selectItemOnCanvas: "Chwazi yon eleman sou canvas la pou modifye pwopriyete li yo",
    
    // Toolbar
    selectMode: "Seleksyon",
    panMode: "Deplase vi",
    undo: "Defèt",
    redo: "Refè",
    cut: "Koupe",
    copy: "Kopye",
    paste: "Kole",
    
    // Mobile
    mobileEdit: "Edisyon Mobil",
    selectMenu: "Chwazi yon meni",
    searchPlaceholder: "Chèche...",
    noResults: "Pa gen rezilta",
    tryAnotherSearch: "Eseye yon lòt rechèch",
    clearSearch: "Efase",
    noTextsInMenu: "Pa gen tèks",
    addTextsFromDesktop: "Ajoute nan editè a",
    changesReflected: "Chanjman yo pral parèt lè ou anrejistre",
    
    // Toasts
    menuCreated: "Meni kreye",
    menuDeleted: "Meni efase",
    menuSaved: "Meni anrejistre",
    linkCopied: "Lyen kopye",
    mobileLinkCopied: "Lyen mobil kopye",
    qrDownloaded: "QR telechaje",
    nameUpdated: "Non mete ajou",
    configUpdated: "Konfigirasyon mete ajou",
    textCopied: "Kopye",
    textCut: "Koupe",
    textPasted: "Kole",
    changeUndone: "Defèt",
    changeRedone: "Refè",
    itemDeleted: "Efase",
    itemAdded: "Ajoute",
    imageUploaded: "Imaj voye",
    export: "Ekspòte",
    exportPNG: "Ekspòte kòm PNG",
    exportJPG: "Ekspòte kòm JPG",
    imageExported: "Imaj ekspòte",
    
    // Admin
    adminPanel: "Panno Administrasyon",
    adminAccessRequired: "Aksè administratè obligatwa",
    userManagement: "Jesyon Itilizatè",
    manageAllUsers: "Jere tout itilizatè sistèm nan",
    addUser: "Ajoute Itilizatè",
    editUser: "Modifye Itilizatè",
    addUserDesc: "Kreye yon nouvo kont itilizatè",
    editUserDesc: "Modifye enfòmasyon itilizatè",
    searchUsers: "Chèche itilizatè...",
    totalUsers: "Total Itilizatè",
    activeUsers: "Itilizatè Aktif",
    totalMenus: "Total Meni",
    totalLocations: "Total Kote",
    role: "Wòl",
    status: "Estati",
    created: "Kreye",
    actions: "Aksyon",
    active: "Aktif",
    inactive: "Inaktif",
    activate: "Aktive",
    deactivate: "Dezaktive",
    userCreated: "Itilizatè kreye",
    userUpdated: "Itilizatè mete ajou",
    userDeleted: "Itilizatè efase",
    userActivated: "Itilizatè aktive",
    userDeactivated: "Itilizatè dezaktive",
    confirmDeleteUser: "Efase itilizatè",
    confirmDeleteUserDesc: "Ou sèten ou vle efase itilizatè",
    deleteUserWarning: "Tout meni ak kote ki asosye ak itilizatè sa a pral efase.",
    fillAllFields: "Ranpli tout chan yo",
    passwordRequired: "Modpas obligatwa",
    leaveBlank: "kite vid pou kenbe",
    accountActive: "Kont aktif",
    noUsersYet: "Pa gen itilizatè ankò",
    create: "Kreye",
    
    // Suspension
    suspended: "Sispann",
    suspendService: "Sispann sèvis",
    suspendServiceDesc: "Sispann sèvis",
    suspensionMessage: "Mesaj sispansyon",
    suspensionMessagePlaceholder: "Sèvis sa a tanporèman sispann...",
    suspensionMessageHelp: "Mesaj sa a pral parèt nan tout meni piblik itilizatè sa a.",
    suspend: "Sispann",
    userSuspended: "Sèvis sispann",
    reactivateService: "Reaktive sèvis",
    serviceReactivated: "Sèvis reaktive",
    
    // Stats detail dialogs
    clickToViewAll: "Klike pou wè tout",
    allMenusDesc: "Lis tout meni sistèm nan",
    searchMenus: "Chèche meni...",
    owner: "Pwopriyetè",
    viewPublic: "Wè piblik",
    allLocations: "Tout Kote yo",
    allLocationsDesc: "Lis tout kote sistèm nan",
    searchLocations: "Chèche kote...",
    menus: "meni",
    
    // Landing Page
    landing_hero_badge: "Platfòm Meni Dijital #1",
    landing_hero_title: "Transfòme meni ou nan yon",
    landing_hero_title_highlight: "eksperyans dijital",
    landing_hero_description: "Kreye meni dijital estrawòdinè pou restoran, kafeteria oswa ba ou. Mete pri ajou, ajoute pwomosyon epi pwograme kontni otomatikman.",
    landing_hero_email_placeholder: "Adrès imèl ou",
    landing_hero_request_demo: "Mande Demo",
    landing_hero_no_credit: "Pa bezwen kat kredi",
    landing_hero_setup_minutes: "Konfigirasyon nan minit",
    landing_hero_support_included: "Sipò enkli",
    landing_features_badge: "KARAKTERISTIK",
    landing_features_title: "Tout sa ou bezwen pou",
    landing_features_highlight: "briye",
    landing_features_desc: "Zouti pwisan ak fasil pou itilize pou kreye meni dijital ki kaptive kliyan ou yo",
    landing_usecases_badge: "KA ITILIZASYON",
    landing_usecases_title: "Pafè pou",
    landing_usecases_highlight: "biznis ou",
    landing_usecases_desc: "Fèt pou restoran, kafeteria, ba ak nenpòt etablisman ki vle modènize meni yo",
    landing_pricing_badge: "PRI",
    landing_pricing_title: "Plan pou chak",
    landing_pricing_highlight: "bezwen",
    landing_pricing_desc: "Kòmanse epi grandi lè ou bezwen. Pa gen angajman, anile nenpòt lè.",
    landing_cta_title: "Ou prè pou transfòme meni ou?",
    landing_cta_desc: "Jwenn dè santèn restoran ki deja ap itilize Sally Better pou kreye eksperyans dijital inik pou kliyan yo.",
    landing_start_now: "Kòmanse Kounye a",
    landing_view_demo: "Wè Demo",
    landing_feature_editor: "Editè Vizyèl Drag & Drop",
    landing_feature_editor_desc: "Desine meni pwofesyonèl san konesans teknik. Trennen ak lage eleman fasil.",
    landing_feature_calendar: "Pwogramasyon pa Kalandriye",
    landing_feature_calendar_desc: "Pwograme otomatikman ki meni pou montre selon jou ak lè. Dejene, manje midi, dine.",
    landing_feature_timezone: "Plizyè Zòn Orè",
    landing_feature_timezone_desc: "Jere restoran nan diferan vil ak zòn orè endepandan.",
    landing_feature_widgets: "Widgèt Dinamik",
    landing_feature_widgets_desc: "Ajoute revèy dijital, previzyon meteyolojik, nouvèl RSS ak tèks anime.",
    landing_feature_slideshows: "Diaporama Otomatik",
    landing_feature_slideshows_desc: "Kreye prezantasyon wotasyon plizyè meni ak tranzisyon dous.",
    landing_feature_qr: "Kòd QR Inik",
    landing_feature_qr_desc: "Jenere kòd QR pou chak meni. Kliyan ou yo eskane epi wè meni a mete ajou.",
    landing_feature_videos: "Videyo ak Imaj",
    landing_feature_videos_desc: "Sipòte videyo YouTube, Vimeo ak fichye dirèk pou meni ki pi atiran.",
    landing_feature_shapes: "Fòm ak Animasyon",
    landing_feature_shapes_desc: "Ajoute fòm jewometrik ak animasyon antre pou kaptive atansyon.",
    landing_usecase_restaurants: "Restoran",
    landing_usecase_restaurants_desc: "Meni dijital ki mete ajou imedyatman. Chanje pri, ajoute plat jou a ak pwomosyon nan segond.",
    landing_usecase_cafes: "Kafeteria",
    landing_usecase_cafes_desc: "Montre kat kafe ou, gato ak pwomosyon maten. Pwograme meni dejene otomatikman.",
    landing_usecase_bars: "Ba",
    landing_usecase_bars_desc: "Kat bwason, happy hour ak evènman espesyal. Mete pri ak pwomosyon aswè ajou imedyatman.",
    landing_plan_basic: "Debaz",
    landing_plan_basic_desc: "Pafè pou kòmanse",
    landing_plan_pro: "Pwofesyonèl",
    landing_plan_pro_desc: "Pou restoran ki ap grandi",
    landing_plan_enterprise: "Antrepriz",
    landing_plan_enterprise_desc: "Pou chèn ak franchiz",
    landing_most_popular: "Pi Popilè",
    landing_contact_sales: "Kontakte Vant",
    landing_per_month: "/mwa",
    landing_custom: "Pèsonalize",
    landing_contact_form_title: "Ranpli enfòmasyon ou yo epi nou pral kontakte ou byento",
    landing_full_name: "Non konplè",
    landing_phone: "Telefòn",
    landing_business_name: "Non biznis",
    landing_message: "Mesaj (opsyonèl)",
    landing_message_placeholder: "Di nou plis sou bezwen ou yo...",
    landing_send_request: "Voye Demann",
    landing_sending: "Voye...",
    landing_message_sent: "Mesaj voye! Nou pral kontakte ou byento.",
    landing_message_error: "Erè nan voye mesaj la. Tanpri eseye ankò.",
    landing_fill_required: "Tanpri ranpli non ak imèl",
    
    // Landing - New Print + Digital Plans
    landing_plan_250: "Plan 250",
    landing_plan_250_price: "$165",
    landing_plan_250_desc: "Ideyal pou restoran piti oswa k ap grandi",
    landing_plan_500: "Plan 500",
    landing_plan_500_price: "$325",
    landing_plan_500_desc: "Pou restoran etabli",
    landing_plan_1000: "Plan 1000",
    landing_plan_1000_price: "$650",
    landing_plan_1000_desc: "Maksimòm kontwòl ak prezans",
    landing_premium: "PREMIUM",
    
    // Plan features
    landing_menus_printed: "meni enprime",
    landing_double_sided_glossy: "de bò (glossy)",
    landing_print_digital_design: "Desen Meni enprime ak Dijital",
    landing_unlimited_changes: "Ajoute pwodwi ak chanjman pri san limit",
    landing_digital_panel_access: "Aksè nan panèl kontwòl Meni Dijital",
    landing_seasonal_changes: "chanjman desen pa sezon",
    landing_seasonal_changes_plural: "chanjman desen pa sezon",
    landing_menu_with_qr: "Meni ak Kòd QR",
    landing_personalized_admin: "Administrasyon pèsonalize pou Meni Dijital ou",
    landing_priority_support: "Sipò priyorite",
    landing_includes_plan: "Karakteristik Plan",
    
    // Landing - All in One Section
    landing_allinone_badge: "SOLISYON TOUT-NAN-YON",
    landing_allinone_title: "Meni Pwofesyonèl",
    landing_allinone_highlight: "Enprime + Dijital",
    landing_allinone_desc: "Yon sèl peman chak mwa, kontwòl total ak imaj pwofesyonèl pou restoran ou",
    landing_allinone_feature1: "Desen Grafik Pwofesyonèl",
    landing_allinone_feature2: "Enpresyon ak materyèl bon kalite",
    landing_allinone_feature3: "Chanjman pri ak pwodwi san limit",
    landing_allinone_feature4: "Desen meni pa sezon",
    landing_allinone_feature5: "Meni ak Kòd QR",
    landing_allinone_feature6: "Meni dijital pou ekran, ak aksè soti nan laptop, tablèt oswa telefòn",
    
    // Landing - Problems Section
    landing_problems_title: "Meni ou an dezòd?",
    landing_problem1: "Chanjman desen ki chè",
    landing_problem2: "Reenprime lè ou chanje pri oswa ajoute nouvo pwodwi",
    landing_problem3: "Menm desen chak ane",
    landing_problem4: "Ekran ki pa mete ajou",
    landing_problems_quote: "Restoran ou chanje tout tan.",
    landing_problems_quote2: "Meni ou ta dwe fè menm bagay la tou.",
    
    // Landing - Comparison Section
    landing_comparison_badge: "KONPAREZON",
    landing_comparison_title: "Poukisa chwazi",
    landing_comparison_highlight: "Sally Better?",
    landing_comparison_desc: "Konpare sèvis konplè nou ak founisè enpresyon tradisyonèl",
    landing_traditional_providers: "Founisè Enpresyon Tradisyonèl",
    landing_our_service: "Sèvis Konplè Nou",
    landing_print_digital_control: "ENPRESYON + DIJITAL + KONTWÒL",
    landing_menus_printed_size: "meni enprime 11x17",
    landing_graphic_design_included: "Desen grafik enkli",
    landing_brand_adaptation: "Adaptasyon mak",
    landing_digital_update_system: "Sistèm aktyalizasyon dijital",
    landing_price_change_access: "Aksè pou chanje pri",
    landing_seasonal_included: "Chanjman sezon enkli",
    landing_personalized_support: "Administrasyon pèsonalize/sipò",
    landing_digital_menu_included: "Meni dijital enkli",
    landing_yes: "Wi",
    landing_no: "Non",
    landing_according_plan: "selon plan",
    landing_plan_1000_plus: "plan 1000+",
    landing_elite_available: "Plan elit disponib",
    landing_more_than_1000: "Plis pase 1,000 meni",
    landing_contact_for_pricing: "Kontakte nou pou pri",
    landing_not_enough_print: "Li pa ase pou enprime.",
    landing_with_our_service: "Ak sèvis nou ou jwenn",
    landing_control_flexibility: "Kontwòl, Fleksibilite ak Teknoloji",
    landing_for_your_restaurant: "pou restoran ou.",
    
    // Landing - Why Choose Us
    landing_why_choose: "Poukisa chwazi nou?",
    landing_fast: "Rapid",
    landing_easy: "Fasil",
    landing_professional: "Pwofesyonèl",
    landing_quality: "Kalite",
    landing_savings: "Ekonomi",
    landing_keep_updated: "Kenbe meni ou ajou san konplikasyon.",
    landing_max_presence: "Maksimòm prezans. Maksimòm Kontwòl.",
    landing_request_consultation: "Pran Randevou Konsiltasyon Gratis",
    
    // Landing - Services Showcase
    landing_services_badge: "SÈVIS NOU YO",
    landing_services_title: "Enpresyon Pwofesyonèl",
    landing_services_highlight: "+ Afichaj Dijital",
    landing_services_desc: "Solisyon konplè pou imaj restoran ou. Depi meni enprime bon kalite rive nan ekran dijital ki ka mete ajou nan tan reyèl.",
    landing_print_menus_title: "Meni Enprime",
    landing_print_menus_desc: "Enpresyon bon kalite sou papye glossy, de bò. Desen pwofesyonèl ki reflete idantite mak ou ak kòd QR entegre.",
    landing_glossy_finish: "Fini Glossy",
    landing_digital_signage_title: "Afichaj Dijital",
    landing_digital_signage_desc: "Ekran dijital pou restoran ou. Mete pri, pwodwi ak pwomosyon ajou nan tan reyèl soti nan nenpòt aparèy.",
    landing_realtime_updates: "Mete Ajou Tan Reyèl",
    landing_mobile_control: "Kontwòl sou Telefòn",
    landing_auto_refresh: "Oto-Rafrechi",
  }
};

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    // 1. Check localStorage first
    const savedLanguage = localStorage.getItem("sally_language");
    if (savedLanguage && ['en', 'es', 'pt', 'ht'].includes(savedLanguage)) {
      return savedLanguage;
    }
    
    // 2. Try to detect browser language
    const browserLang = navigator.language?.split('-')[0];
    if (browserLang === 'es') return 'es';
    if (browserLang === 'pt') return 'pt';
    if (browserLang === 'ht') return 'ht';
    
    // 3. Default to English
    return 'en';
  });

  // Save language to localStorage whenever it changes
  const setLanguage = (newLanguage) => {
    if (['en', 'es', 'pt', 'ht'].includes(newLanguage)) {
      setLanguageState(newLanguage);
      localStorage.setItem("sally_language", newLanguage);
    }
  };

  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };

  const availableLanguages = [
    { code: "en", name: "English", flag: "🇺🇸" },
    { code: "es", name: "Español", flag: "🇪🇸" },
    { code: "pt", name: "Português", flag: "🇧🇷" },
    { code: "ht", name: "Kreyòl", flag: "🇭🇹" },
  ];

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, availableLanguages }}>
      {children}
    </LanguageContext.Provider>
  );
};
